import { useConfigurationSelector } from "@redux/reducers/appConfig";
import {
  useBusinessModelSelector,
  useFinanceSimulationSelector,
} from "@redux/reducers/deal";
import { useIsKeyAccount } from "@redux/reducers/auth";
import {
  JOURNEY_TYPE,
  REGISTRATION_AVAILABILITY_STATUS,
  REGISTRATION_SWITCH_VARIANT,
} from "@shared/constants";
import { getSolJourneyConfigForJourney } from "@shared/v2/lib/getSolJourneyConfigForJourney";
import { computeAvailableRegistrationMethods } from "@lib/computeAvailableRegistrationMethods";
import { useResolvedRegistrationPostalCode } from "@hooks/useResolvedRegistrationPostalCode";
import { useRegistrationCountryFilter } from "@hooks/useRegistrationCountryFilter";

const getSwitchVariant = currentJourney => {
  if (currentJourney === JOURNEY_TYPE.CASH) {
    return REGISTRATION_SWITCH_VARIANT.TO_FINANCE;
  }
  return REGISTRATION_SWITCH_VARIANT.TO_CASH;
};

export const useRegistrationAvailabilityGate = () => {
  const configuration = useConfigurationSelector();
  const businessModel = useBusinessModelSelector();
  const financeSimulation = useFinanceSimulationSelector();
  const isKeyAccount = useIsKeyAccount();
  const registrationPostalCode = useResolvedRegistrationPostalCode();
  const buildCountryFilter = useRegistrationCountryFilter();

  const currentJourney = financeSimulation.journey;

  const countryFilter = buildCountryFilter();

  const journeysWithMethods = Object.values(JOURNEY_TYPE).filter(journey => {
    let journeyConfig;
    try {
      journeyConfig = getSolJourneyConfigForJourney(
        journey,
        businessModel,
        configuration
      );
    } catch (e) {
      return false;
    }
    if (!journeyConfig || journeyConfig.enabled === false) {
      return false;
    }
    const methods = computeAvailableRegistrationMethods(
      journeyConfig.vehicleRegistration,
      registrationPostalCode,
      { isKeyAccount, ...countryFilter }
    );
    return methods.length > 0;
  });

  if (journeysWithMethods.includes(currentJourney)) {
    return {
      status: REGISTRATION_AVAILABILITY_STATUS.OK,
      otherAvailableJourneys: [],
      switchVariant: null,
    };
  }

  if (journeysWithMethods.length === 0) {
    return {
      status: REGISTRATION_AVAILABILITY_STATUS.NO_JOURNEY_AVAILABLE,
      otherAvailableJourneys: [],
      switchVariant: null,
    };
  }

  return {
    status: REGISTRATION_AVAILABILITY_STATUS.SWITCH_REQUIRED,
    otherAvailableJourneys: journeysWithMethods,
    switchVariant: getSwitchVariant(currentJourney),
  };
};
